import { ServiceOffering } from './ServiceOfferingsContracts';
import { GetFareV5Request, GetFareV5Response } from './FareEntities';
import { ServiceResult } from './ServiceEntities';
import { Get, Post, GetManagementServiceRootUrlWithoutState } from './ServiceManager';
import { BookingRequestV2 } from './BookingEntitiesV2';
import { BookingAuthority } from './BookingEntities';

/** Base URL for the ServiceOffering in the Booking Management Service. */
function GetBaseUrl(): string {
    return `${GetManagementServiceRootUrlWithoutState()}ServiceOffering/`;
}

/** Client for the ServiceOffering controller in the Management API */
class ServiceOfferingsServiceClass {

    /** Get service offerings for a specific suburb. */
    public GetServiceOfferings(suburbId: number): Promise<ServiceResult<ServiceOffering[]>> {
        const url = `${GetBaseUrl()}GetServiceOfferings?suburbId=${suburbId}`;
        return Get<ServiceOffering[]>(url);
    }

    /** Get fare estimates (V5) for the specified locations and parameters. */
    public GetFareV5(request: GetFareV5Request): Promise<ServiceResult<GetFareV5Response>> {
        const url = `${GetBaseUrl()}GetFareV5`;
        return Post<GetFareV5Response>(url, request);
    }

    /** Create booking using V2 API (ServiceOfferings-based booking path). 
     * Returns BookingAuthority (bookingId + hashCode) as ServiceResult unwraps the API response. */
    public CreateBookingV2(request: BookingRequestV2): Promise<ServiceResult<BookingAuthority>> {
        const url = `${GetBaseUrl()}CreateBookingV2`;
        return Post<BookingAuthority>(url, request);
    }

}

/** Singleton export for static access to the operations */
export const ServiceOfferingsService = new ServiceOfferingsServiceClass();
